export default "__VITE_PUBLIC_ASSET__e3a939da__"